import { Button, Checkbox, Divider, Typography } from 'antd';
import styled from 'styled-components';

export const ExportFileButtonStyled = styled(Button)`
  // Stile da applicare quando il pulsante si trova in un Menu Dropdown
  // per dare l'aspetto del menù e farli occupare tutto lo spazio disponibile.
  &.ant-btn-text {
    .ant-dropdown-menu & {
      justify-content: flex-start;
      width: 100%;
    }
  }
`;

/**
 * Trigger basato su `<span>` usato dentro i menu item dei Dropdown
 * per evitare la violazione WCAG button-in-button
 * (`<li role="menuitem">` è già interattivo — annidare un `<button>`
 * al suo interno non è valido).
 */
export const MenuItemTrigger = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 12px;
  cursor: pointer;
`;

export const ExportCurrentPageCheckbox = styled(Checkbox)`
  order: 4;
`;

export const ExportModalDivider = styled(Divider)`
  &&& {
    margin-block: 4px;
  }
`;

export const ConfirmDivider = styled(ExportModalDivider)`
  order: 5;
`;

export const ConfirmText = styled(Typography.Text)`
  order: 6;
`;

export const ClosingDivider = styled(ExportModalDivider)`
  order: 7;
`;
